import Modal from "react-bootstrap/Modal";
import {ModalBody, ModalFooter, ModalHeader} from "react-bootstrap";
import {useTranslation} from "react-i18next";
import React, {useState} from "react";
import Style from "../Style.module.css";


export default function MentorCabinetTransactionsDismisWarning(props) {
    const { t, i18n } = useTranslation('translation', { keyPrefix: 'payments' });
    const [checkApproved, setCheckApproved] = useState(false)

    return <Modal
        show={true}
        onHide={props.closeModal}
        size="lg"
    >
        <ModalHeader
            closeButton={true}
        />
        <ModalBody>
            {t('ask dismiss bonus')}
            <br/>
            {props.days && <b> {props.days + t('bonus days')}</b>}
            {props.coins && <b>{(props.coins || 0) + t('bonus coins')}</b>}
            <br/>
            <br/>
            <input type="checkbox" checked={checkApproved} onChange={() => setCheckApproved(!checkApproved)}/>
            {t('dismiss check agree')}
        </ModalBody>
        <ModalFooter>
            <input
                type="button"
                disabled={!checkApproved}
                className={Style.dismissRefBonusButton}
                value={t('referralBonusDismiss')}
                onClick={props.onConfirm}
            />
        </ModalFooter>
    </Modal>
}